import { Navigate, Outlet } from 'react-router-dom'

import { logger } from '@/lib/logger'
import { isUserRestricted } from '@/lib/roles'

import { useAuthStore } from '@/stores/auth'

import { paths } from '@/config/paths'

export default function PrivateRoute() {
  const user = useAuthStore((state) => state.user)

  if (!user) return <Navigate to={paths.public.auth.login.getHref()} replace />

  // Block access for banned, suspended, or deleted users
  if (isUserRestricted(user)) {
    logger.warn('Restricted user attempting to access protected route', {
      userId: user.id,
      status: user.status,
    })
    return <Navigate to={paths.public.unauthorized.getHref()} replace />
  }

  logger.debug('PrivateRoute render')

  return <Outlet /> // render child routes
}
